<template>

  <footer id="footer" class="uk-responsive-height"
          v-if="footer.list"
  >
    <section id="social-media">
      <div class="uk-container uk-container-large uk-padding-large">
        <div class="uk-align-center uk-width-2-3@l">

            <social-sharing url="https://www.martinsorgel.de"
                            title="Werde Klangpate für eine Orgelpfeife der neuen Chororgel des Freiburger Münsters!"
                            description="Werde Klangpate für eine Orgelpfeife der neuen Chororgel des Freiburger Münsters!"
                            quote="Werde Klangpate für eine Orgelpfeife der neuen Chororgel des Freiburger Münsters!"
                            hashtags="Münster, Freiburg, Chororgel, Kirche"
                            inline-template>
              <div class="uk-child-width-1-4" data-uk-grid>
                <div>
                  <h3>Teilen</h3>
                </div>
                <network network="twitter" @close="closeTwitter()">
                  <span class="uk-icon-button" data-uk-icon="icon: twitter; ratio:1.5"></span>
                </network>
                <network network="facebook" @close="closeFacebook()">
                  <span class="uk-icon-button" data-uk-icon="icon: facebook; ratio:1.5"></span>
                </network>
                <network network="email">
                  <span class="uk-icon-button" data-uk-icon="icon: mail; ratio:1.5"></span>
                </network>
              </div>
            </social-sharing>
        </div>
      </div>
    </section>
    <section id="sponsorship" class="uk-light">
      <div class="uk-container uk-container-large" v-for="f in footer.list" v-bind:key="f.id">
        <div id="our-sponsors">
          <h5>{{f.headline}}</h5>
          <div class="uk-child-width-1-6@m uk-grid-match" data-uk-grid>
            <div v-for="s in repeater_sponsors_organization.list" v-bind:key="s.id"
                 class="uk-height-small uk-flex uk-flex-middle">
              <a v-bind:href="s.http_url" target="_blank">
                <img v-bind:src="s.image[0].httpUrl" v-bind:alt="s.image[0].description"
                     v-bind:width="s.image[0].width" v-bind:height="s.image[0].height"
                     v-if="s.image[0].ext === 'svg'" data-uk-svg
                >
                <img v-bind:src="s.image[0].httpUrl" v-bind:alt="s.image[0].description"
                     v-bind:width="s.image[0].width" v-bind:height="s.image[0].height"
                     v-else
                >
              </a>
            </div>
          </div>
        </div>
        <hr class="uk-hr uk-margin-large">
        <div id="footer-info" class="uk-flex uk-flex-around">
          <ul class="uk-subnav" data-uk-margin>
            <li class="uk-active"><a href="#" v-on:click.prevent="openModal('imprint')">{{imprint.title}}</a></li>
            <li><a href="#" v-on:click.prevent="openModal('privacy-policy')">{{privacy_policy.title}}</a></li>
          </ul>
          <div v-html="f.body_text"></div>
          <div id="contact" itemscope itemtype="http://schema.org/Organization">
            <p>
              <span itemprop="name">{{f.name_text}}</span>
            </p>
            <p itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">
              <span itemprop="streetAddress">{{f.street}}</span><br>
              <span itemprop="postalCode">{{f.postal_code}}</span>
              <span itemprop="addressLocality">{{f.city}}</span>
            </p>
            <p>
              <span itemprop="telephone">{{f.phone_number}}</span><br>
              <span itemprop="faxNumber">{{f.fax_number}}</span>
            </p>
            <p>
              <a itemprop="email" :href="'mailto:' + f.email">{{f.email}}</a>
            </p>
          </div>
        </div>
      </div>
    </section>

    <modal name="imprint" :adaptive="true" :scrollable="true"
           width="60%" height="auto" transition="scale"
    >
      <div class="uk-panel">
        <div class="uk-position-top-right uk-margin-small-top uk-margin-small-right uk-position-z-index">
          <a href="#" class="uk-icon-link" data-uk-icon="icon: close; ratio:2;" v-on:click.prevent="hideModal('imprint')"></a>
        </div>
        <div class="uk-panel uk-padding-large">
          <h3>{{imprint.title}}</h3>
          <div id="imprint-text" v-html="imprint.body_text"></div>
        </div>
      </div>
    </modal>

    <modal name="privacy-policy" :adaptive="true" :scrollable="true"
           width="60%" height="auto" transition="scale"
    >
      <div class="uk-panel">
        <div class="uk-position-top-right uk-margin-small-top uk-margin-small-right uk-position-z-index">
          <a href="#" class="uk-icon-link" data-uk-icon="icon: close; ratio:2;" v-on:click.prevent="hideModal('privacy-policy')"></a>
        </div>
        <div class="uk-panel uk-padding-large">
          <h3>{{privacy_policy.title}}</h3>
          <div id="privacy-policy-text" v-html="privacy_policy.body_text"></div>
        </div>
      </div>
    </modal>

  </footer>

</template>
<script>
import {FOOTER, FOOTER_SPONSORS, IMPRINT, PRIVACY_POLICY} from '../../constants/graphql'

export default {
  name: 'site-footer',
  data () {
    return {
      footer: {},
      repeater_sponsors_organization: {},
      imprint: {},
      privacy_policy: {},
      loading: 0
    }
  },
  apollo: {
    footer: {
      query: FOOTER
    },
    repeater_sponsors_organization: {
      query: FOOTER_SPONSORS
    },
    imprint: {
      query: IMPRINT,
      update (data) {
        return data.imprint.list[0]
      }
    },
    privacy_policy: {
      query: PRIVACY_POLICY,
      update (data) {
        return data.privacy_policy.list[0]
      }
    }
  },
  methods: {
    closeTwitter () {
      // console.info('Danke fürs Twittern!')
    },
    closeFacebook () {
      // console.info('Danke fürs teilen mit Facebook!')
    },
    openModal (name) {
      this.$modal.show(name)
    },
    hideModal (name) {
      this.$modal.hide(name)
    }
  }
}
</script>
<style lang="scss">
  @import "../../assets/scss/variables";
  @import "../../assets/scss/mixins";

  @import '~uikit/src/scss/variables-theme';

  $icon-button-size: 36px;

  #social-media {
    h3 {
      @include fontSize(35px);
    }
    background-color: transparentize($color-light-blue, 0.8);
    .uk-icon-button {
      width: $icon-button-size * 1.5;
      height: $icon-button-size * 1.5;
      background: white;
      &:hover {
        cursor: pointer;
      }
    }
  }
  #sponsorship {
    background: -moz-linear-gradient(270deg, #60A0C2 0%, #2E6494 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #60A0C2), color-stop(100%, #2E6494));
    background: -webkit-linear-gradient(270deg, #60A0C2 0%, #2E6494 100%);
    background: -o-linear-gradient(270deg, #60A0C2 0%, #2E6494 100%);
    background: -ms-linear-gradient(270deg, #60A0C2 0%, #2E6494 100%);
    background: linear-gradient(180deg, #60A0C2 0%, #2E6494 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#60A0C2', endColorstr='#2E6494', GradientType=0);

    .uk-container {
      padding-top: 5em;
      padding-bottom: 5em;
    }
  }

  #our-sponsors {
    svg {
      color: #ffffff;
      max-width: 100%;
    }
    @media (max-width: $breakpoint-small-max) {
      [data-uk-grid] {
        div {
          padding-right: 5em;
        }
      }
    }
  }

  #footer-info {
    @media (max-width: $breakpoint-small-max) {
      display: block;
      .uk-subnav {
        display: block;
        & + div {
          margin-top: 4em;
          & + #contact {
            margin-top: 4em;
          }
        }
      }
    }
  }

  #contact {
    * {
      font-size: calculateRem(18px);
      line-height: 1.3;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Global/SiteFooter.vue